import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./styles/TransferLocations.css";
import "./styles/MyListedLicenses.css";

const LISTINGS_STORAGE_KEY = "marketplace_listings_v1";

const formatMoney = (value) => {
  if (typeof value !== "number" || Number.isNaN(value)) return "—";
  return `$${value.toLocaleString()}`;
};

const formatDate = (iso) => {
  if (!iso) return "—";
  const date = new Date(iso);
  return Number.isNaN(date.getTime()) ? "—" : date.toLocaleDateString();
};

export default function MyListedLicenses() {
  const navigate = useNavigate();
  const [listings, setListings] = useState([]);

  useEffect(() => {
    const stored = JSON.parse(localStorage.getItem(LISTINGS_STORAGE_KEY) || "[]");
    setListings(stored);
  }, []);

  const handleCancel = (id) => {
    const updated = listings.filter((listing) => listing.id !== id);
    setListings(updated);
    localStorage.setItem(LISTINGS_STORAGE_KEY, JSON.stringify(updated));
  };

  const listingCards = useMemo(
    () =>
      listings.map((listing) => {
        const typeLabel = listing.type === "auction" ? "Auction" : "Flat Cost";
        const priceSummary =
          listing.type === "auction"
            ? `Min: ${formatMoney(listing.minPrice)} • Base: ${formatMoney(
                listing.basePrice
              )}`
            : `Price: ${formatMoney(listing.flatPrice)}`;

        return (
          <div key={listing.id} className="transfer-card listed-card">
            <div className="transfer-card-header">
              <div className="transfer-card-header-block">
                <div className="transfer-label">Listing Type</div>
                <div className="transfer-value">{typeLabel}</div>
              </div>
              <div className="transfer-card-header-block">
                <div className="transfer-label">Status</div>
                <div className="transfer-status-wrapper">
                  <span className="transfer-status-pill transfer-status-pill--pending">
                    Listed
                  </span>
                </div>
              </div>
            </div>
            <div className="transfer-card-body">
              <div className="transfer-locations-block">
                <div className="transfer-label">Location</div>
                <div className="transfer-locations-list">
                  <div className="transfer-location-item">
                    <div className="transfer-location-name">{listing.name}</div>
                    <div className="transfer-location-address">{listing.address}</div>
                  </div>
                </div>
                <div className="listed-meta">
                  <div>
                    <span className="listed-meta-label">Pricing</span>
                    <span className="listed-meta-value">{priceSummary}</span>
                  </div>
                  <div>
                    <span className="listed-meta-label">Expires</span>
                    <span className="listed-meta-value">{formatDate(listing.expiresAt)}</span>
                  </div>
                </div>
              </div>
              <div className="transfer-actions-block">
                <div className="transfer-label">Actions</div>
                <div className="transfer-actions-buttons">
                  <button className="btn btn-primary" onClick={() => handleCancel(listing.id)}>
                    Cancel Listing
                  </button>
                </div>
              </div>
            </div>
          </div>
        );
      }),
    [listings]
  );

  return (
    <div className="listed-page">
      <div className="page-header">
        <div>
          <p className="page-eyebrow">Marketplace</p>
          <h2>My Listed Licenses</h2>
          <p className="section-subtitle">
            Track active listings and cancel if needed.
          </p>
        </div>
        <div className="listed-header-actions">
          <button className="btn btn-secondary" onClick={() => navigate("/marketplace")}>
            Back to Marketplace
          </button>
        </div>
      </div>

      <section className="page-section listed-panel">
        {listings.length === 0 ? (
          <p className="listed-empty">No listed licenses yet.</p>
        ) : (
          <div className="listed-grid">{listingCards}</div>
        )}
      </section>
    </div>
  );
}
